import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Container, Grid } from "@material-ui/core";
import {
  SimpleLoading,
  PromotionalFooterPure,
  // ColumnChartHLPure,
} from "../../pures";
import { HeaderHLPure, CardMenuHLPure } from "../../pures";
import "./help-desk.css";


const HelpDeskView = (props) => {
  let {
    cardHelpDesk
  } = props

  const { t } = useTranslation();
  const [cards, setCards] = useState([])

  useEffect(() => {
    if (!cardHelpDesk || cardHelpDesk.length === 0) return
    setCards(cardHelpDesk)
  }, [cardHelpDesk])

  const setSubCards = (card) => {
    let subCardsToShow = (card.subCards) ? card.subCards : []
    setCards(subCardsToShow)
  }

  return (
    <div className="standard-wrapper">
      {props.loading ? (
        <SimpleLoading />
      ) : (
        <Container
          xs={12}
          lg={12}
          md={12}
          sm={12}
          spacing={4}
          className="helpDeskView-container"
        >
          {/*Header*/}
          <Grid
            item
            lg={12}
            md={12}
            xs={12}
            sm={12}
          // className="helpDeskView-header"
          >
            <HeaderHLPure
              title={t("app.action.helpDesk")}
              subtitleActive={false}
            />
          </Grid>

          {/*Container primera seccion de items, fila*/}
          <Grid
            lg={12}
            md={12}
            xs={12}
            sm={12}
            container
            className="helpDeskView-navbar"
          >
            {/*Cards container */}
            {cards.map((item, index) => (
              <Grid className={"helpDeskView-containerCardsGrid"}>
                <CardMenuHLPure
                  {...item}
                  key={item.title}
                  url={item.url}
                  altImg={item.altImg}
                  imgBackCard={item.imgBackCard}
                  img={item.img}
                  title={item.title}
                  text={item.text}
                  onClick={(item.subCards && item.subCards.length > 0) ? () => setSubCards(item) : null}
                />
              </Grid>
            ))}
          </Grid>

          {/*Seccion de fila para footer */}
          <Grid item xs={12} lg={12} md={12} sm={12}>
            <PromotionalFooterPure />
          </Grid>
        </Container>
      )}
    </div>
  );
};

export default HelpDeskView;
